import { OidcClient } from "oidc-client"

const azure = {
    providerHeaderName: "AZURE",
    oidcClient: new OidcClient({
        authority: "https://login.microsoftonline.com/common/",
        client_id: window.sso_config.azure["CLIENT_ID"],
        redirect_uri: `${window.location.origin}/rhumbix/azure-callback/`,
        response_type: "id_token",
        scope: "openid",
        filterProtocolClaims: true,
        loadUserInfo: true,
    }),
}

const oneLogin = {
    providerHeaderName: "ONELOGIN",
    oidcClient: new OidcClient({
        authority: "https://openid-connect-us.onelogin.com/oidc",
        client_id: window.sso_config.onelogin["CLIENT_ID"],
        redirect_uri: `${window.location.origin}/rhumbix/sso-callback/`,
        response_type: "id_token token",
        scope: "openid profile",
        filterProtocolClaims: true,
        loadUserInfo: true,
    }),
}

export const ssoConfigurations = { azure, oneLogin }
